import { defineMessages } from 'react-intl';

export const messages: {
	videoThumbnailAltText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	videoIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dropdownMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	videoType: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	gongTopics: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	durationInSeconds: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	durationInMinutes: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	durationInMinutesAndSeconds: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	durationInHours: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	durationInHoursOnly: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	seeAll: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pastMeetings: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pastMeetingsUpdated: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sharedLinks: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	inMeetingChat: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	videoThumbnailAltText: {
		id: 'search-graph-video.video-thumbnail-alt-text',
		defaultMessage: 'Video thumbnail',
		description:
			'Alternative text for the video thumbnail image shown in a video search result, read by screen readers.',
	},
	videoIconLabel: {
		id: 'search-graph-video.video-icon-label',
		defaultMessage: 'video icon',
		description:
			'Accessible label for the video type icon shown in a video search result, read by screen readers.',
	},
	dropdownMessage: {
		id: 'search-graph-video.dropdown-message',
		defaultMessage:
			'{chapterCount, plural, one {# chapter in this video} other {# chapters in this video}}',
		description: 'Dropdown message for video search result',
	},
	videoType: {
		id: 'search-graph-video.video-type',
		defaultMessage: 'Video',
		description:
			'Badge label shown on a video search result to indicate the result type is a video.',
	},
	gongTopics: {
		id: 'search-graph-video.gong-topics',
		defaultMessage:
			'{chapterCount, plural, one {# topic in this call} other {# topics in this call}}',
		description: 'Button label to expand the topics in a Gong call search result.',
	},
	durationInSeconds: {
		id: 'search-graph-video.duration.seconds',
		defaultMessage: '{seconds} sec',
		description:
			'Text shown in a video search result to display a duration in seconds only. The placeholder {seconds} is substituted with the number of seconds.',
	},
	durationInMinutes: {
		id: 'search-page.search-page-relay.search-results.search-result.search-result-renderer.search-graph-result.search-graph-video.durationInMinutes',
		defaultMessage: '{minutes} min',
		description:
			'Text shown in a video search result to display a duration in whole minutes. The placeholder {minutes} is substituted with the number of minutes.',
	},
	durationInMinutesAndSeconds: {
		id: 'search-page.search-page-relay.search-results.search-result.search-result-renderer.search-graph-result.search-graph-video.durationInMinutesAndSeconds',
		defaultMessage: '{minutes} min {seconds} sec',
		description:
			'Text shown in a video search result to display a duration in minutes and seconds. The placeholders {minutes} and {seconds} are substituted with the corresponding parts of the duration.',
	},
	durationInHours: {
		id: 'search-graph-video.duration.hours',
		defaultMessage: '{hours} hour {minutes} min',
		description:
			'Text shown in a video search result to display a duration in hours and minutes. The placeholder {hours} is substituted with the number of hours and {minutes} with the remaining minutes.',
	},
	durationInHoursOnly: {
		id: 'search-page.search-page-relay.search-results.search-result.search-result-renderer.search-graph-result.search-graph-video.durationInHoursOnly',
		defaultMessage: '{hours, plural, one {# hour} other {# hours}}',
		description:
			'Text shown in a video search result to display a duration using only its largest unit in hours.',
	},
	seeAll: {
		id: 'search-graph-video.see-all',
		defaultMessage: 'See all',
		description: 'Label for a link to see all video chapters',
	},
	pastMeetings: {
		id: 'search-graph-video.past-meetings',
		defaultMessage: 'Past meetings',
		description: 'Button label to expand past occurrences of a recurring meeting transcript',
	},
	pastMeetingsUpdated: {
		id: 'search-graph-video.past-meetings-updated',
		defaultMessage: 'Updated {relativeTime}',
		description: 'Relative time label for past meeting transcript items',
	},
	sharedLinks: {
		id: 'search-graph-video.shared-links',
		defaultMessage: 'Shared links',
		description: 'Button label to expand links shared during a video meeting.',
	},
	inMeetingChat: {
		id: 'search-graph-video.in-meeting-chat',
		defaultMessage: 'In-Meeting Chat',
		description: 'Button label to open or download the chat transcript for a video meeting.',
	},
});
